import { useTranslation } from 'react-i18next';
import React, {useEffect, useState,Fragment } from "react";
import { useNavigate } from "react-router-dom";
import apiRequest from '../../functions/api';
import LoadingComponent from '../LoadingComponent/LoadingComponent';
import { Grid, Card, Box,Hidden, TableContainer,Table,TableBody,TableRow,TableCell} from '@mui/material'
import { useMessage } from "../../context/message-context";
import Projektstundenwoche from "../Projektstundenwoche";
import { Routes, Route} from "react-router-dom";
import ListAltIcon from '@mui/icons-material/ListAlt'
function ProjektstundenArchiv(props) {
  const { t } = useTranslation();
  const {client, accessToken, admin, userid, updateTitle} = props;
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const {showErrorMessage} = useMessage();
  const [user,setUser]=useState("");
  const [kws,setKws]=useState([]);
  const archiv="J"
  useEffect(() => {
    setIsLoading(true);
    const payload={
      "mandant": client, // this.props.client,
      "program": (admin==="J")?"PPROJ3":"PPROJN",
      "statement": "ARCHIV",
      "admin":admin,
      "userid":userid,
    }
    const headers={
      "Authorization": "Bearer "+accessToken,
    }
    apiRequest('POST', 'daten', payload, headers, postUebersicht);
    // eslint-disable-next-line
  }, [])
  const postUebersicht=(response)=>{
    setIsLoading(false);
    if (response.status === 200) {
        setUser(response.data.user)
        setKws(response.data.kws)
    } else {
        if (response) {
            showErrorMessage(response.data.message);
        } else {
            showErrorMessage(t("Keine Internetverbindung"));
        }
    }
  }
  if (isLoading) {
    return <LoadingComponent path={props.location}/>
  }
  function Auswahl(key){
    if (admin==="J"){
      navigate('/PPROJ3/PPROJN/archiv/'+user+key)
    }else{
      navigate('/PPROJN/archiv/'+user+key)
    }
    
  }
  function AnzeigeDesktop(preitem){
    return(
      <Fragment>
        {(preitem.kw&&preitem.kw.length>0)&&preitem.kw.map((item,index)=>{
          return(
          <Fragment>
            {(index===0)&&
                <TableRow style={{backgroundColor:`rgba(${"240"},${"240"},${"240"},0.5)`, color:`rgba(${"000"},${"000"},${"000"},1)`, border:`1px solid rgba(${"224"},${"224"},${"224"},1)`}}>
                  <TableCell colspan={4} >{"Jahr "+item.jahr}</TableCell>
                </TableRow>
            }
            <TableRow style={{cursor: 'pointer', border:`1px solid rgba(${"224"},${"224"},${"224"},1)`}} hover key={item.key} onClick={() => Auswahl(item.key)}>
              <TableCell><ListAltIcon color="primary"/></TableCell>
              <TableCell>{"Kalenderwoche "+item.kw}</TableCell>
              <TableCell>{"Jahr "+item.jahr}</TableCell>
              <TableCell>{item.von+" - "+item.bis}</TableCell>
            </TableRow>
          </Fragment>
          )
        })}   
      </Fragment>
    )
  }
  function AnzeigeMobil(preitem){
    return(
      <Fragment>
        {(preitem.kw&&preitem.kw.length>0)&&preitem.kw.map((item,index)=>{
          return(
          <Fragment>
            {(index===0)&&
                <TableRow style={{backgroundColor:`rgba(${"240"},${"240"},${"240"},0.5)`, color:`rgba(${"000"},${"000"},${"000"},1)`, border:`1px solid rgba(${"224"},${"224"},${"224"},1)`}}>
                  <TableCell colspan={4} >{"Jahr "+item.jahr}</TableCell>
                </TableRow>
            }
            <TableRow style={{cursor: 'pointer', border:`1px solid rgba(${"224"},${"224"},${"224"},1)`}} hover key={item.key} onClick={() => Auswahl(item.key)}>
              <TableCell><ListAltIcon color="primary"/></TableCell>
              <TableCell>{"Kalenderwoche "+item.kw}<br/>{"Jahr "+item.jahr}<br/>{item.von+" - "+item.bis}</TableCell>
            </TableRow>
          </Fragment>
          )
        })}   
      </Fragment>
    )
  }
  function Anzeige(){
    return (
        <Grid container justifyContent="center" spacing={2}>
            {(kws&&kws.length>0)&&kws.map((item,index)=>{
                return(
                    <Grid item xs={12} md={8}>
                    <Card >   
                      <Box p={2}>
                        <Grid container justifyContent="center" spacing={2}>
                        <Grid item xs={12}>
                        <TableContainer>
                          <Table size="small">
                            <TableBody>
                              <Hidden lgDown>
                                {AnzeigeDesktop(item)}
                              </Hidden>
                              <Hidden lgUp>
                                {AnzeigeMobil(item)}
                              </Hidden>                          
                            </TableBody>
                          </Table>
                        </TableContainer>
                        </Grid>
                        </Grid>
                      </Box>
                    </Card>
                    </Grid>
                )
            })}
        </Grid>
    )
   }

    return (
      <Routes>
        <Route path="/:antragid" element={<Projektstundenwoche updateTitle={(t) => updateTitle(t)} client={client} accessToken={accessToken} admin={admin} userid={userid} archiv={archiv}/>}/>  
        <Route path="/" element={Anzeige()}/>
      </Routes>  
    )
}
export default ProjektstundenArchiv;
